import { render, staticRenderFns } from "./ChannelBalanceAdjustOrderEdit.vue?vue&type=template&id=0405a03d&"
import script from "./ChannelBalanceAdjustOrderEdit.vue?vue&type=script&lang=ts&"
export * from "./ChannelBalanceAdjustOrderEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChannelBalanceAdjustOrderEdit.vue"
export default component.exports